import {useEffect} from "react";
import GeneralStats from "../../../components/debit-table/casino-debit-stats";
import SvgIcon from "../../../components/svg-icon";

const BetsModal = props => {
    const {handleClose} = props


    useEffect(() => {
        const bdy = document.body
        bdy.classList?.add('modal-open')

        const mdl = document.getElementById('bets-modal')
        mdl.classList?.add('show')

        mdl.style.display = 'block'
        mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

        return () => {
            bdy.classList?.remove('modal-open')
            mdl.classList?.remove('show')

        }
    }, [])


    return (
        <div
            className="modal fade"
            id="bets-modal"
            onClick={handleClose}
        >

            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal__content" onClick={e => e.stopPropagation()}>
                        <div className="modal__head">
                            <h6 className="modal__title">Bets</h6>
                            <button
                                className="modal__close"
                                type="button"
                                aria-label="Close"
                                onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>
                        <GeneralStats/>
                    </div>
                </div>
            </div>
        </div>

    )

}

export default BetsModal
